import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request';
import { firstValueFrom } from 'rxjs';

// ▪ @numRegs es una variable de tipo int que indica el máximo número de registros a devolver
// ▪ @liRuleNr es una variable de tipo tinyint que almacena el ID de una regla
// ▪ @lvAuftrNr es una variable de tipo tinyint que almacena el ID de una petición
// ▪ @Desde es una variable de tipo datetime que almacena la fecha y hora inicial de la búsqueda
// ▪ @Hasta es una variable de tipo datetime que almacena la fecha y hora final de la búsqueda
// mode: WxrlLogsMode
export type WxrlRuleLogsFilter = {
  labNr?: number;
  ruleState?: string;
  subjectType?: string;
  subjectID?: number;
  mode?: WxrlLogsMode;
  desde?: Date;
  hasta?: Date;
  maxRows?: number;
  text?: string;
};

// TimeWhen datetime NOT NULL, -- Fecha y hora de registro de la Incidencia.
// AuftrNr varchar(14) NULL, -- Petición de prueba (si activado el modo prueba)
// Eindat datetime NULL, -- Fecha de registro de la petición.
// RuleNr int NULL, -- Referencia a la regla que genera el log.
// What varchar(2000) NULL -- Registro de la incidencia.
export type WxrlLog = {
  timeWhen: Date;
  auftrNr: string;
  einDat: Date;
  ruleNr: number;
  what: string;
};

export type WxrlLogsMode = 'rule' | 'request';

@Injectable({
  providedIn: 'root',
})
export class WrxlLogsService {
  constructor(private request: RequestService) {}

  listLogs(filters: WxrlRuleLogsFilter): Promise<WxrlLog[]> {
    console.log('listLogs', filters);
    const params = new URLSearchParams();
    if (filters.labNr) {
      params.append('labNr', filters.labNr.toString());
    }
    if (filters.ruleState) {
      params.append('ruleState', filters.ruleState);
    }
    if (filters.subjectType) {
      params.append('subjectType', filters.subjectType);
    }
    if (filters.subjectID) {
      params.append('subjectID', filters.subjectID.toString());
    }
    if (filters.mode) {
      params.append('mode', filters.mode);
    }
    if (filters.desde) {
      params.append('desde', filters.desde.getTime().toString());
    }
    if (filters.hasta) {
      params.append('hasta', filters.hasta.getTime().toString());
    }
    if (filters.maxRows) {
      params.append('maxRows', filters.maxRows.toString());
    }
    if (filters.text) {
      params.append('text', filters.text);
    }

    console.log('params', params.toString());

    return firstValueFrom(
      this.request.get(`/api/wxrl/logs?${params.toString()}`)
    );
  }
}
